import styled from "@emotion/styled";
import { DatePicker } from "office-ui-fabric-react";

export const FormDatePicker = styled(DatePicker)<{
  hasError: boolean;
  background?: string;
}>`
  .ms-TextField-fieldGroup {
    border: none;
    &::after {
      display: none;
    }
    background-color: ${p => p.background ?? undefined};
  }
  .ms-TextField-wrapper {
    border-bottom: 1px solid ${p => p.theme.palette.neutralTertiaryAlt};
    &:focus-within {
      border-color: ${p =>
        p.hasError ? p.theme.palette.red : p.theme.palette.themePrimary};
    }
  }
  .ms-TextField-suffix {
    padding-right: 32px;
    background: transparent;
  }
  .ms-TextField.is-disabled {
    .ms-TextField-fieldGroup {
      background-color: ${p => p.background ?? undefined};
    }
    input {
      background-color: transparent;
    }
  }
`;
